import { Action, createReducer, on } from '@ngrx/store';

import { initialState, EntityPersonasState } from './entity-personas.state';
import { entityPersonasAdapter } from './entity-personas.state';
import {
  entityPersonasLoadRequest,
  entityPersonasLoadSuccess,
  entityPersonasLoadFailure,
  entityPersonasAddFailure,
  entityPersonasAddRequest,
  entityPersonasAddSuccess,
  entityPersonasChangeFailure,
  entityPersonasChangeRequest,
  entityPersonasChangeSuccess,
  entityPersonasDeleteFailure,
  entityPersonasDeleteRequest,
  entityPersonasDeleteSuccess,
  entityPersonasChangeSuccessWithoutRedirection
} from './entity-personas.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityPersonasLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasLoadSuccess, (state, { items }) =>
    entityPersonasAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // add
  on(entityPersonasAddRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasAddFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasAddSuccess, (state, { item }) =>
    entityPersonasAdapter.addOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // change
  on(entityPersonasChangeRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasChangeFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasChangeSuccess, (state, { item }) =>
    entityPersonasAdapter.updateOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  on(entityPersonasChangeSuccessWithoutRedirection, (state, { item }) =>
    entityPersonasAdapter.updateOne(item, {
      ...state,
      isLoading: false,
      error: null
    })
  ),
  // delete
  on(entityPersonasDeleteRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityPersonasDeleteFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityPersonasDeleteSuccess, (state, { item }) =>
    entityPersonasAdapter.removeOne(item.id, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function personasReducer(
  state: EntityPersonasState | undefined,
  action: Action
) {
  return reducer(state, action);
}
